<template>
  <div
    @dragover.prevent="dragOver"
    @dragleave.prevent="dragLeave"
    @drop.prevent="drop($event)"
    :class="files.length == 0 ? 'mx-2 my-4':''"
  >
    <div class="drop" v-show="dropped == 2"></div>

    <div v-show="files.length == 0" class="beforeUpload">
      <input
        type="file"
        style="z-index: 1"
        ref="uploadInput"
        @change="previewFiles"
        multiple
      />

      <img :src="'/img/upload-document.svg'" class="box__icon">

      <p class="mainMessage">
        Нажмите мышкой либо перенесите файлы сюда
      </p>
    </div>
    <div class="filesPreview" v-show="files.length > 0">
      <ul class="list-group">
        <li class="list-group-item item-preview-doc"
            v-for="(file, index) in files"
            :key="index"
        >
          {{ file.name }} <span class="remove-file float-right cursor-pointer" v-on:click="deleteFile(index)"><i class="far fa-trash-alt doc-trash text-danger"></i></span>
        </li>
      </ul>
      <!--        <div class="plus" @click="append" v-if="++index == files.length">+</div>-->
    </div>
  </div>
</template>
<script>
  export default {
    name: "FilesUploadArea",
    data() {
      return {
        files: [],
        dropped: 0,
      };
    },
    methods: {
      dragOver() {
        this.dropped = 2;
      },
      dragLeave() {},
      drop(e) {
        let files = Array.from(e.dataTransfer.files)
        if (e && files) {
          this.files.push(...files);
          this.previewFiles();
        }
        this.dropped = 0;
      },
      append() {
        this.$refs.uploadInput.click();
      },
      readAsDataURL(file) {
        return new Promise(function (resolve, reject) {
          let fr = new FileReader();
          fr.onload = function () {
            resolve(fr.result);
          };
          fr.onerror = function () {
            reject(fr);
          };
          fr.readAsDataURL(file);
        });
      },
      deleteFile(index) {
        this.files.splice(index, 1);
        this.$emit("changed", this.files);
        this.$refs.uploadInput.value = null;
      },
      previewFiles(event) {
        if (this.dropped == 0) this.files.push(...event.currentTarget.files);
        this.$emit("changed", this.files);
        let readers = [];

        if (!this.files.length) return;
        for (let i = 0; i < this.files.length; i++) {
          readers.push(this.readAsDataURL(this.files[i]));
        }
      },
      reset() {
        this.$refs.uploadInput.value = null;
        this.files = [];
        this.$emit("changed", this.files);
      },
    },
  };
</script>

<style scoped>
  .drop {
    width: 100%;
    height: 100%;
    top: 0;
    border-radius: 10px;
    position: absolute;
    background-color: #f4f6ff;
    left: 0;
    border: 3px dashed #a3a8b1;
  }
  .beforeUpload {
    position: relative;
    text-align: center;
  }
  .beforeUpload input {
    width: 100%;
    margin: auto;
    height: 100%;
    opacity: 0;
    position: absolute;
    background: red;
    display: block;
  }
  .beforeUpload input:hover {
    cursor: pointer;
  }
  .plus:hover {
    cursor: pointer;
  }
</style>
